import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useToastStore } from '../state/toastStore.ts';
import { Button } from '../ui/index.ts';
import { usePwaStore } from './pwaStore.ts';
import styles from './Pwa.module.css';

/**
 * Says a new version of the app is ready (and lets the player take it when it suits them), and, once,
 * that the game now works without a network. Never in the middle of a heist or a training run.
 */
export function UpdateBanner() {
  const { t } = useTranslation('pwa');
  const location = useLocation();
  const needRefresh = usePwaStore((s) => s.needRefresh);
  const offlineReady = usePwaStore((s) => s.offlineReady);
  const apply = usePwaStore((s) => s.applyUpdate);
  const later = usePwaStore((s) => s.later);
  const acknowledge = usePwaStore((s) => s.acknowledgeOffline);
  const push = useToastStore((s) => s.push);

  useEffect(() => {
    if (!offlineReady) return;
    push(t('offlineReady'), 'success');
    acknowledge();
  }, [offlineReady, push, t, acknowledge]);

  if (!needRefresh) return null;
  if (location.pathname === '/game' || location.pathname === '/training') return null;
  return (
    <div className={styles['update']} role="status" data-testid="update-banner">
      <span className={styles['text']}>{t('updateReady')}</span>
      <Button onClick={apply}>{t('update')}</Button>
      <Button variant="ghost" onClick={later}>
        {t('later')}
      </Button>
    </div>
  );
}
